var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useStyledModal } from '@/hooks/use-styled-modal.hook';
import { ButtonBase, Typography } from '@mui/material';
export function Disclaimer() {
    var _a = useStyledModal(_jsx(DisclaimerContent, {})), modal = _a[0], toggleModal = _a[1];
    function soundNotPlayingClicked() {
        toggleModal();
    }
    return (_jsxs("div", __assign({ className: 'flex flex-col items-center md:gap-20 gap-10' }, { children: [_jsx(ButtonBase, __assign({ className: "w-fit", onClick: soundNotPlayingClicked }, { children: _jsx(Typography, __assign({ className: "text-xl underline underline-offset-2 decoration-1 cursor-pointer md:text-white" }, { children: "Disclaimer" })) })), modal] })));
}
function DisclaimerContent() {
    return (_jsxs("div", __assign({ className: "flex flex-col gap-8 text-center px-8" }, { children: [_jsx(Typography, __assign({ variant: "h2", className: "md:text-4xl text-3xl font-extrabold" }, { children: "Disclaimer" })), _jsx(Typography, __assign({ className: "md:text-xl text-lg font-normal md:font-medium leading-normal max-w-[44rem]" }, { children: "This screening is for informational purposes only and does not constitute medical advice. The information provided is not intended as a medical diagnosis nor as a diagnostic hearing evaluation. Consult a hearing care professional for a diagnosis or, if you are experiencing pain or discomfort, or if you have experienced a sudden change in hearing. This screener is intended for use only for ages 18 and above.\"" }))] })));
}
